import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MainStore } from "../../store";
import {
  format_seconds_to_measure_beat,
  format_seconds_to_smpte
} from "../../util/text_formatting";
import { SnapControls } from "../SnapControls";
import { ZoomControls } from "../ZoomControls";
import { Container, TimeControls, ZoomIcon } from "./styles";
import { Zoom } from "../../../assets/Zoom";
import { ZOOM_HOVER, ZoomButtonHoverAction } from "../../actions/actionTypes";

export let ProjectInfoGrid = () => {
  const dispatch = useDispatch();
  const time = useSelector<MainStore, number>(
    state => state.editorState.locatorTime
  );
  const bpm = useSelector<MainStore, number>(
    state => state.project.initialTrackData.bpm
  );
  const beatsPerMeasure = useSelector<MainStore, number>(
    state => state.project.initialTrackData.beatsPerMeasure
  );

  const zoomHover = useSelector<MainStore, boolean>(
    state => state.uiState.zoomHover
  );

  const onMouseEnter = () => {
    dispatch<ZoomButtonHoverAction>({
      type: ZOOM_HOVER,
      zoomHover: true
    });
  };

  return (
    <Container>
      <ZoomControls />
      <TimeControls className={zoomHover ? null : "active"}>
        <div className="time">
          <div className="smpte">{format_seconds_to_smpte(time)}</div>
          <div className="measures-beats">
            {format_seconds_to_measure_beat(time, bpm, beatsPerMeasure)}
          </div>
        </div>
        <SnapControls />
        <Container className="zoom-button tight" onMouseEnter={onMouseEnter}>
          <ZoomIcon className="zoom-icon">
            <Zoom />
          </ZoomIcon>
        </Container>
      </TimeControls>
    </Container>
  );
};
